export const handleDropAccepted = async ({
    uploadFiles,
    acceptedFiles,
    handleClearErrors,
    onDropAccepted
}) => {
    typeof onDropAccepted === "function" && onDropAccepted(acceptedFiles);
    handleClearErrors();
    await uploadFiles(acceptedFiles);
};

export const handleDropRejected = ({
    fileRejections,
    setRejectedFileErrors
}) => {
    !!setRejectedFileErrors &&
        setRejectedFileErrors(
            fileRejections.map((rejectedFile, index) => {
                return {
                    index: index,
                    name: rejectedFile.file.name,
                    size: rejectedFile.file.size,
                    errors: rejectedFile.errors
                };
            })
        );
};
